import { Navigate } from "react-router-dom";
import { useTenantAuth } from "../context/auth";

export function ProtectedRoute({ children }: { children: React.ReactElement }) {
  const { token, bootstrap, isLoading } = useTenantAuth();
  if (isLoading || (token && !bootstrap)) {
    return <div className="p-6">Loading...</div>;
  }
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
